import { Modal } from 'antd';
import { ReactNode } from 'react';

import Icon from '@ant-design/icons';

import * as St from './ConfigurableModal.styles';

import TrashIcon from '~/icons/trash-remove.svg';

type ConfigurableModalProps = Pick<
  React.ComponentProps<typeof Modal>,
  | 'className'
  | 'closable'
  | 'destroyOnClose'
  | 'footer'
  | 'keyboard'
  | 'maskClosable'
  | 'width'
  | 'forceRender'
> & {
  title?: string;
  isVisible: boolean;
  onClose: (value: boolean) => void;
  container?: string;
  content?: ReactNode;
  type?: 'warning' | 'info' | 'remove' | 'other';
};

const ConfigurableModal = ({
  title,
  isVisible,
  onClose,
  container,
  content,
  type,
  ...props
}: ConfigurableModalProps): JSX.Element => (
  <Modal
    title={!type ? title : null}
    getContainer={container}
    open={isVisible}
    onCancel={() => onClose(false)}
    width={props.width ?? 'auto'}
    centered
    {...props}
  >
    {type === 'info' && <St.Title>{title}</St.Title>}
    {type === 'warning' && (
      <St.WarningHeader>
        <Icon component={() => <St.WarningIcon />} />
        <St.WarningTitle>{title}</St.WarningTitle>
      </St.WarningHeader>
    )}
    {type === 'remove' && <St.WarningTitle>{title}</St.WarningTitle>}
    {type === 'remove' ? (
      <St.Content className="modal-content" data-type="remove">
        <Icon component={() => <TrashIcon />} />
        <St.RemoveContent>{content}</St.RemoveContent>
      </St.Content>
    ) : (
      <St.Content className="modal-content">{content}</St.Content>
    )}
  </Modal>
);

export default ConfigurableModal;
